import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin-leads", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // Clear hash + go to admin
        window.history.replaceState(null, "", "/admin-leads");
        navigate("/admin-leads", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Sign-in failed");
        setTimeout(() => navigate("/admin-leads", { replace: true }), 2000);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0A0B0E] text-white flex items-center justify-center">
      <div className="text-center">
        <div className="kicker mb-3">Signing you in</div>
        <div className="font-display text-2xl">Verifying your session…</div>
        {error && <div className="mt-4 text-red-400 text-sm" data-testid="auth-error">{error}</div>}
      </div>
    </div>
  );
}
